define(["require", "exports", "tslib", "moment", "../../utils/Environment", "../entity/PermitLicItemDef", "./EventManager", "./index"], function (require, exports, tslib_1, moment_1, Environment_1, PermitLicItemDef_1, EventManager_1, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AppConfigManager = void 0;
    moment_1 = tslib_1.__importDefault(moment_1);
    class AppConfigManager {
        constructor() {
            Object.defineProperty(this, "activeConfiguration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitLicenseItems", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitStockRefData", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitDocumentTypeRefData", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaDocumentTypeRefData", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SmaCategoryReferenceData", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SmaConditionReferenceData", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SmaConditions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "withinVersionDateRange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (date, from, to) => {
                    const applyDate = (x) => {
                        return !!x && x != "-1";
                    };
                    const parseDate = (x) => {
                        return (0, moment_1.default)(x, "DD-MM-YYYY").toDate();
                    };
                    var _from = !applyDate(from) || date >= parseDate(from);
                    var _to = !applyDate(to) || date < parseDate(to);
                    return _from && _to;
                }
            });
        }
        ActiveConfiguration() {
            return this.activeConfiguration;
        }
        static get Instance() {
            return new Promise((resolve, reject) => {
                if (this.instance == null) {
                    this.instance = new AppConfigManager();
                    this.instance.readConfiguration().then(res => {
                        resolve(this.instance);
                    }).catch(err => {
                        reject(err);
                    });
                }
                else {
                    resolve(this.instance);
                }
            });
        }
        static get InstanceSync() {
            return this.instance;
        }
        readConfiguration() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let applyConfiguration = (result) => {
                    this.activeConfiguration = result;
                    this.PermitLicenseItems = result.PermitLicenseItemDef.map(x => new PermitLicItemDef_1.PermitLicItemDef(x));
                    this.PermitStockRefData = result.PermitStockDef;
                    this.PermitDocumentTypeRefData = result.PermitDocumentTypeDef;
                    this.WaDocumentTypeRefData = result.WaDocumentTypeDef;
                    this.SmaCategoryReferenceData = result.SmaCategoryDef;
                    this.SmaConditionReferenceData = result.SmaConditionDef;
                    this.SmaConditions = Array.from(new Set((this.SmaConditionReferenceData || []).map(x => x.Condition)));
                };
                let readFromServer = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    console.log("Reading config from server");
                    (0, EventManager_1.notify)(`Loading application (${(0, Environment_1.getVersion)()} ${(0, Environment_1.getEnvironment)()})`);
                    const config = yield index_1.SrmsServiceManager.Instance.Common.getConfiguration();
                    if (!config) {
                        throw new Error("Configuration failed to load");
                    }
                    return config;
                });
                const config = yield readFromServer();
                applyConfiguration(config);
                return this;
            });
        }
        getHarvestingPermitTimeRule(permit) {
            var _a;
            var permitStartDate = new Date((_a = permit.HarvestingPermit.FinalStartDt) !== null && _a !== void 0 ? _a : permit.HarvestingPermit.StartDt);
            var rule = this.activeConfiguration.Configuration.HarvestingPermit.TimeRules.find(x => this.withinVersionDateRange(permitStartDate, x.From, x.To));
            if (rule == null) {
                throw new Error("Could not resolve rule by start date");
            }
            return rule;
        }
        getGrazingPermitStockFeeRule(permit, stockType) {
            var _a;
            var permitStartDate = new Date((_a = permit.GrazingPermit.FinalStartDt) !== null && _a !== void 0 ? _a : permit.GrazingPermit.StartDt);
            var rule = this.activeConfiguration.Configuration.GrazingPermit.StockFeeRules.find(x => x.StockType == stockType && this.withinVersionDateRange(permitStartDate, x.From, x.To));
            if (rule == null) {
                throw new Error("Could not derive a Grazing Permit Fee Rule from provided Stock Type");
            }
            return rule;
        }
        getTravelSpeedRule(permit, travelType) {
            for (let rule of this.activeConfiguration.Configuration.TravelPermit.SpeedRules) {
                if (rule.TravelType == travelType) {
                    return rule;
                }
            }
            throw new Error("Could not derive a Travel rule from provided values: Travel Type: " + travelType);
        }
        getPermitStockType(stockName, stockClass) {
            for (let rule of this.PermitStockRefData) {
                if (rule.StockName == stockName && rule.StockClass == stockClass) {
                    return rule.StockType;
                }
            }
            throw new Error("Could not derive a Stock definition from provided Stock Name: " + stockName);
        }
        getDocumentTypesByPermit(permitType, permitLicenseStatus) {
            let result = [];
            for (let documentType of this.PermitDocumentTypeRefData) {
                if ((documentType.PermitType == -1 || documentType.PermitType == permitType) && documentType.LicenseStatus == permitLicenseStatus) {
                    result.push(documentType);
                }
            }
            return result;
        }
        getDocumentTypesByWaterAgreement(wa) {
            let result = [];
            for (let documentType of this.WaDocumentTypeRefData) {
                if ((documentType.AgreementType == -1 || documentType.AgreementType == wa.AgreementType) && documentType.ApprovalStatus == wa.ApprovalStatus) {
                    result.push(documentType);
                }
            }
            return result;
        }
        getSmaSubCategoriesBySmaCategoryGroup(categoryGroup) {
            let result = [];
            for (let categoryDef of this.SmaCategoryReferenceData) {
                if (categoryDef.CategoryGroup == categoryGroup) {
                    result.push(categoryDef.Category);
                }
            }
            return result;
        }
    }
    exports.AppConfigManager = AppConfigManager;
});
